export default {"src":"/_next/static/media/right.cb695bf5.svg","height":8,"width":14};